import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, FreeMode, Thumbs } from 'swiper/modules';
import DataTable from 'datatables.net-dt';
export default class CategorizedDownloads {
    constructor() {
        this.section = document.querySelector('.categorized-downloads');

        this.slider = this.section.querySelector('.swiper--categorized-downloads');
        this.navigationPrev = document.querySelector('.slider-button-prev--categorized-downloads');
        this.navigationNext = document.querySelector('.slider-button-next--categorized-downloads');

        this.allTables = this.section.querySelectorAll('table');

        this.ready();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination, Thumbs],
            grabCursor: false,
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: false,
            autoHeight: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            pagination: {
                el: this.section.querySelector('.swiper-pagination-custom'),
                clickable: true,
                renderBullet: (index, className) => {
                    const getNameBullet = this.slider.querySelectorAll('.swiper-slide')[index].dataset.titulo;
                    return '<button class="' + className + '">' + getNameBullet + '</button>';
                },
            },
            lockClass: 'navigationLock',
        });

        const tables = this.section.querySelectorAll('.tablePaginateDataTable');
        tables.forEach((row, index) => {
            if (row.classList.contains('reverse')) {
                const tbody = row.querySelector('tbody');
                const rows = Array.from(tbody.querySelectorAll('tr'));
                rows.reverse();
                tbody.innerHTML = '';
                rows.forEach((r) => {
                    tbody.appendChild(r);
                });
            }
        });

        new DataTable('.tablePaginateDataTable', {
            searching: false,
            ordering: false,
            pageLength: 7,
            lengthChange: false,
            info: false,
        });
    }
}

if (document.querySelector('.categorized-downloads')) {
    new CategorizedDownloads();
}
